import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const BoltColor2 = ({ height = 26, width = 24, ...props }: SvgIconProps) => {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 15 18" {...props}>
      <g filter="url(#a)">
        <path
          fill="url(#b)"
          d="m3.71 10.03 3.234.97.411 4.434a.5.5 0 0 0 .931.204l3.583-6.21a1 1 0 0 0-.58-1.458L8.057 7l-.411-4.434a.5.5 0 0 0-.93-.204L3.13 8.572a1 1 0 0 0 .58 1.458Z"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="11.5"
          x2="1.221"
          y1="1"
          y2="4.411"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF4D80" />
          <stop offset=".067" stopColor="#FE4D81" />
          <stop offset=".133" stopColor="#FC4E82" />
          <stop offset=".2" stopColor="#F95086" />
          <stop offset=".267" stopColor="#F4528A" />
          <stop offset=".333" stopColor="#EE5490" />
          <stop offset=".4" stopColor="#E65897" />
          <stop offset=".467" stopColor="#DE5B9F" />
          <stop offset=".533" stopColor="#D65FA7" />
          <stop offset=".6" stopColor="#CE62AF" />
          <stop offset=".667" stopColor="#C666B6" />
          <stop offset=".733" stopColor="#C068BC" />
          <stop offset=".8" stopColor="#BB6AC0" />
          <stop offset=".867" stopColor="#B86CC4" />
          <stop offset=".933" stopColor="#B66DC5" />
          <stop offset="1" stopColor="#B56DC6" />
        </linearGradient>
        <filter
          id="a"
          width="13.006"
          height="17.777"
          x=".997"
          y=".112"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation=".5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_18064_59041" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend in2="effect1_dropShadow_18064_59041" result="effect2_dropShadow_18064_59041" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation=".5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend in2="effect2_dropShadow_18064_59041" result="effect3_dropShadow_18064_59041" />
          <feBlend in="SourceGraphic" in2="effect3_dropShadow_18064_59041" result="shape" />
        </filter>
      </defs>
    </SvgIcon>
  );
};
